import { render, staticRenderFns } from "./select-culture.vue?vue&type=template&id=4c1d6819"
import script from "./select-culture.vue?vue&type=script&lang=js"
export * from "./select-culture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports